var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.liveMap = new function () {
    var self = this;
    this.init = function () {
        this.loadLivemap();
    }

    this.loadLivemap = function () {
       
        $('.livemap-tab').on('click', function () {
            $(".livemap-content").html("");
            var target = "#target-" + $(this).data("target");

            $(target).append('<iframe src="https://live.midttrafik.dk/livemap.php" frameborder="0"></iframe>');
        })
    }
} ();






